import React from 'react';
import { motion } from 'framer-motion';
import { SlideWrapper, staggerContainer, fadeUpItem, scaleUpItem } from '../Shared';
import { Bot, CheckCircle2, TrendingDown, TrendingUp, Eye, ShieldCheck, Sparkles } from 'lucide-react';
const VEXU_LOGO = 'https://cdn.magicpatterns.com/uploads/v9ygAz6j1H3a29mCiVRRuK/vexu_logo.svg';
const NEXA_LOGO = 'https://cdn.magicpatterns.com/uploads/fKbS8KZb8wagSLFNLZymLJ/nexa42_png.png';
export function Slide11() {
  const rows = [{
    cap: 'Communication',
    old: 'Slack, Teams',
    new: 'Built-in'
  }, {
    cap: 'Document Management',
    old: 'Drive, Dropbox',
    new: 'Native'
  }, {
    cap: 'Digital Signature',
    old: 'DocuSign, Adobe Sign',
    new: 'Embedded'
  }, {
    cap: 'Workflow Automation',
    old: 'Zapier, Pipefy',
    new: 'Advanced Engine'
  }, {
    cap: 'Forms',
    old: 'Typeform, Jotform',
    new: 'Integrated'
  }, {
    cap: 'Task Management',
    old: 'Monday, Asana',
    new: 'Unified'
  }];
  return <SlideWrapper data-id="element-243">
      <motion.div variants={staggerContainer} initial="hidden" animate="show" className="h-full flex flex-col justify-center gap-0" data-id="element-244">
        <motion.div variants={fadeUpItem} className="mb-6 md:mb-8 flex flex-col md:flex-row justify-between items-start md:items-end gap-4" data-id="element-245">
          <div data-id="element-246">
            <h2 className="text-2xl md:text-4xl font-heading font-bold mb-1 text-charcoal-900 flex items-center gap-2 md:gap-3" data-id="element-247">
              <img src={NEXA_LOGO} alt="Nexa42" className="h-6 md:h-10 object-contain" data-id="element-248" />{' '}
              vs Traditional Systems
            </h2>
            <p className="text-base md:text-xl text-gray-500" data-id="element-249">
              The Killer Comparison
            </p>
          </div>
          <div className="bg-mint-100 border border-vexu-200 px-4 py-2 md:px-6 md:py-3 rounded-xl shadow-sm" data-id="element-250">
            <p className="text-vexu-600 font-bold tracking-wide text-xs md:text-[0.875rem]" data-id="element-251">
              Replace 6–10 systems with 1 platform
            </p>
          </div>
        </motion.div>

        <motion.div variants={scaleUpItem} className="mb-6 md:mb-8 overflow-x-auto rounded-2xl border border-gray-200 bg-white shadow-sm" data-id="element-252">
          <table className="w-full text-left border-collapse table-fixed" data-id="element-253">
            <thead data-id="element-254">
              <tr className="bg-gray-50 text-gray-500 text-xs md:text-sm uppercase tracking-wider border-b border-gray-200" data-id="element-255">
                <th className="p-2 md:p-5 font-medium text-[0.625rem] md:text-[0.75rem] w-[35%] md:w-auto" data-id="element-256">
                  Capability
                </th>
                <th className="p-2 md:p-5 font-medium text-[0.625rem] md:text-[0.75rem] w-[35%] md:w-auto" data-id="element-257">
                  Existing Tools
                </th>
                <th className="p-2 md:p-5 font-medium text-vexu-600 w-[30%] md:w-auto" data-id="element-258">
                  <img src={NEXA_LOGO} alt="Nexa42" className="h-4 md:h-6 object-contain" data-id="element-259" />
                </th>
              </tr>
            </thead>
            <tbody data-id="element-260">
              {rows.map((row, i) => <tr key={i} className="border-b border-gray-100 hover:bg-mint-50/50 transition-colors" data-id="element-261">
                  <td className="p-2 md:p-5 font-medium text-charcoal-800 text-[0.625rem] md:text-[0.875rem] py-1.5 md:py-[0.25rem]" data-id="element-262">
                    {row.cap}
                  </td>
                  <td className="p-2 md:p-5 text-gray-500 text-[0.625rem] md:text-[0.875rem] py-1.5 md:py-[0.25rem]" data-id="element-263">
                    {row.old}
                  </td>
                  <td className="p-2 md:p-5 py-1.5 md:py-[0.25rem]" data-id="element-264">
                    <div className="flex items-center gap-1 md:gap-2 text-vexu-600 font-semibold text-[0.625rem] md:text-[0.875rem]" data-id="element-265">
                      <CheckCircle2 className="w-3 h-3 md:w-5 md:h-5 shrink-0" data-id="element-266" />
                      {row.new}
                    </div>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </motion.div>

        {/* Cost & Complexity Visual */}
        <motion.div variants={fadeUpItem} className="p-4 md:p-5 rounded-2xl bg-white border border-gray-100 shadow-sm pt-0 pb-0" data-id="element-267">
          <div className="grid grid-cols-2 gap-4 md:gap-6 pt-[0.75rem] pb-[0.75rem]" data-id="element-268">
            <div className="text-center" data-id="element-269">
              <p className="text-xs md:text-sm font-semibold text-red-500 mb-2 uppercase tracking-wider" data-id="element-270">
                Traditional Stack
              </p>
              <div className="flex items-end justify-center gap-0.5 md:gap-1 h-12 md:h-16" data-id="element-271">
                {[60, 45, 70, 55, 80, 50].map((h, i) => <div key={i} className="w-4 md:w-6 rounded-t bg-red-200 border border-red-300" style={{
                height: `${h}%`
              }} data-id="element-272" />)}
              </div>
              <p className="text-[0.625rem] md:text-xs text-gray-500 mt-2" data-id="element-273">
                6–10 separate licenses & costs
              </p>
            </div>
            <div className="text-center" data-id="element-274">
              <div className="flex justify-center mb-2" data-id="element-275">
                <img src={NEXA_LOGO} alt="Nexa42" className="h-4 md:h-6 object-contain" data-id="element-276" />
              </div>
              <div className="flex items-end justify-center gap-1 h-12 md:h-16" data-id="element-277">
                <div className="w-12 md:w-16 rounded-t bg-vexu-400 border border-vexu-500" style={{
                height: '45%'
              }} data-id="element-278" />
              </div>
              <p className="text-[0.625rem] md:text-xs text-gray-500 mt-2" data-id="element-279">
                1 platform · All included
              </p>
            </div>
          </div>
        </motion.div>
      </motion.div>
    </SlideWrapper>;
}
export function SlideNexa42View() {
  return <SlideWrapper className="items-center text-center" data-id="element-280">
      <motion.div variants={staggerContainer} initial="hidden" animate="show" className="max-w-6xl w-full h-full flex flex-col items-center justify-center" data-id="element-281">
        <motion.div variants={fadeUpItem} className="mb-4 md:mb-6 flex items-center gap-2 md:gap-3" data-id="element-282">
          <img src={NEXA_LOGO} alt="Nexa42" className="h-6 md:h-10 object-contain" data-id="element-283" />
        </motion.div>
        <motion.p className="text-[20px] pt-[0px] pb-[29px] ml-[0px] mr-[0px] font-[400] font-['Segoe_UI',_sans-serif]" data-id="element-284">
          Exploring the Nexa42 Interface
        </motion.p>
        <motion.div variants={scaleUpItem} className="w-full flex-1 min-h-0 flex items-center justify-center text-[18px] font-[500] text-[#292929] pt-[7px] pb-[7px]" data-id="element-285">
          {/* Desktop: single composite image */}
          <img src="https://cdn.magicpatterns.com/uploads/3iqfHyY9YsynGpEcMkF9io/image.png" alt="Nexa42 App Overview" className="hidden md:block w-full h-full object-contain rounded-2xl max-h-[70vh]" data-id="element-286" />
          {/* Mobile: 4 images stacked with overlap */}
          <div className="flex flex-col md:hidden w-full gap-[32px] items-center justify-center" data-id="element-287">
            {[{
            src: 'https://cdn.magicpatterns.com/uploads/9hrZv4eUYAH8ae8kMZRUor/image.png',
            alt: 'Nexa42 Projects & Tasks Dashboard'
          }, {
            src: 'https://cdn.magicpatterns.com/uploads/3NM4K6YR63373ErgmweNvz/image.png',
            alt: 'Nexa42 Messages & Chat'
          }, {
            src: 'https://cdn.magicpatterns.com/uploads/uVaZpQG4mQu29tQVzYnxdM/image.png',
            alt: 'Nexa42 Workflow Engine'
          }, {
            src: 'https://cdn.magicpatterns.com/uploads/8NfCQhCteGV1T7yzP7xQeU/image.png',
            alt: 'Nexa42 Task Detail'
          }].map((img, i) => <img key={i} src={img.src} alt={img.alt} className="w-[90%] object-contain rounded-xl " style={{
            marginTop: i > 0 ? '-1rem' : 0,
            position: 'relative',
            zIndex: 4 - i
          }} data-id="element-288" />)}
          </div>
        </motion.div>
      </motion.div>
    </SlideWrapper>;
}
export function Slide12() {
  return <SlideWrapper data-id="element-289">
      <motion.div variants={staggerContainer} initial="hidden" animate="show" className="h-full flex flex-col justify-center" data-id="element-290">
        <motion.div variants={fadeUpItem} className="mb-6 md:mb-10 flex items-center gap-3 md:gap-4" data-id="element-291">
          <img src={VEXU_LOGO} alt="Vexu AI" className="w-8 h-8 md:w-12 md:h-12 object-contain" data-id="element-292" />
          <div data-id="element-293">
            <h2 className="text-2xl md:text-4xl font-heading font-bold mb-1 text-charcoal-900" data-id="element-294">
              AI Inside Every Workflow
            </h2>
            <p className="text-base md:text-xl text-vexu-600 flex items-center gap-1 md:gap-2" data-id="element-295">
              <Sparkles className="w-4 h-4 md:w-5 md:h-5" data-id="element-296" /> The Key
              Differentiator
            </p>
          </div>
        </motion.div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 md:gap-12 mb-6 md:mb-10" data-id="element-297">
          <motion.div variants={scaleUpItem} className="p-5 md:p-8 rounded-3xl bg-white border border-gray-200 shadow-sm space-y-[0px] pt-[16px] pb-[16px]" data-id="element-298">
            <h3 className="text-xl md:text-2xl font-bold font-heading mb-4 md:mb-6 flex items-center gap-2 md:gap-3 text-charcoal-900" data-id="element-299">
              <div className="p-1.5 md:p-2 rounded-lg bg-mint-100 text-vexu-600" data-id="element-300">
                <Bot className="w-5 h-5 md:w-6 md:h-6" data-id="element-301" />
              </div>
              With Vexu AI
            </h3>
            <ul className="md:space-y-5 space-y-[12px] pt-[0px] pb-[0px]" data-id="element-302">
              {['AI can execute tasks autonomously', 'Continue workflows without human input', 'Communicate naturally with users'].map((item, i) => <li key={i} className="flex items-center gap-3 md:gap-4 md:text-xl text-gray-700 text-[18px]" data-id="element-303">
                  <div className="w-1.5 h-1.5 md:w-2 md:h-2 rounded-full bg-vexu-500 shrink-0" data-id="element-304" />
                  {item}
                </li>)}
            </ul>
          </motion.div>

          <motion.div variants={scaleUpItem} className="p-3 md:p-8 rounded-3xl bg-mint-50 border border-vexu-200 shadow-sm pt-[16px] pb-[16px]" data-id="element-305">
            <h3 className="text-xl md:text-2xl font-bold font-heading mb-4 md:mb-6 text-charcoal-900" data-id="element-306">
              Example Flow
            </h3>
            <div className="flex flex-col gap-3 md:gap-4 items-start justify-start" data-id="element-307">
              {['AI calls a manager', 'Gets verbal approval', 'Updates workflow automatically'].map((step, i) => <div key={i} className="flex items-center gap-3 md:gap-4" data-id="element-308">
                  <div className="w-6 h-6 md:w-8 md:h-8 rounded-full bg-vexu-500 text-white flex items-center justify-center font-bold text-xs md:text-sm shrink-0 shadow-sm" data-id="element-309">
                    {i + 1}
                  </div>
                  <div className="p-3 md:p-2 rounded-xl  flex-1 md:text-lg font-medium  text-[#009D41] bg-[#00C85300] text-[16px] pt-[2px] pb-[2px]" data-id="element-310">
                    {step}
                  </div>
                </div>)}
            </div>
          </motion.div>
        </div>

        <motion.div variants={fadeUpItem} className="text-center mb-6 md:mb-8" data-id="element-311">
          <p className="md:text-2xl font-heading text-[18px] font-[500] text-[#505050]" data-id="element-312">
            "Automation becomes execution, not just support"
          </p>
        </motion.div>

        {/* AI Workflow Diagram */}
        <motion.div variants={fadeUpItem} className="p-4 md:p-5 rounded-2xl bg-white border border-gray-100 shadow-sm overflow-x-auto pb-6" data-id="element-313">
          <div className="flex flex-col md:flex-row items-center md:justify-between gap-2" data-id="element-314">
            {[{
            label: 'TRIGGER',
            desc: '📋 Approval Needed',
            labelColor: 'text-blue-500',
            bg: 'bg-blue-50 border-blue-200'
          }, {
            label: 'AI ACTION',
            desc: '📞 Calls Manager',
            labelColor: 'text-vexu-600',
            bg: 'bg-mint-100 border-vexu-200'
          }, {
            label: 'RESPONSE',
            desc: '✅ Approved',
            labelColor: 'text-green-600',
            bg: 'bg-green-50 border-green-200'
          }, {
            label: 'EXECUTE',
            desc: '⚡ Workflow Updated',
            labelColor: 'text-amber-600',
            bg: 'bg-amber-50 border-amber-200'
          }, {
            label: 'NOTIFY',
            desc: '🔔 Team Alerted',
            labelColor: 'text-purple-600',
            bg: 'bg-purple-50 border-purple-200'
          }].map((step, i) => <div key={i} className="flex flex-col md:flex-row items-center gap-2 w-full md:w-auto" data-id="element-315">
                <div className={`flex-1 w-full md:w-auto p-2 md:p-3 rounded-xl border text-center ${step.bg}`} data-id="element-316">
                  <p className={`text-[0.625rem] md:text-xs font-semibold ${step.labelColor}`} data-id="element-317">
                    {step.label}
                  </p>
                  <p className="text-xs md:text-sm font-bold text-charcoal-900 mt-0.5 md:mt-1" data-id="element-318">
                    {step.desc}
                  </p>
                </div>
                {i < 4 && <div className="text-vexu-400 font-bold text-xs md:text-base hidden md:block" data-id="element-319">
                    →
                  </div>}
                {i < 4 && <div className="text-vexu-400 font-bold text-xs md:hidden" data-id="element-320">
                    ↓
                  </div>}
              </div>)}
          </div>
        </motion.div>
      </motion.div>
    </SlideWrapper>;
}
export function Slide13() {
  const stats = [{
    value: '40–70%',
    label: 'Cost Reduction',
    icon: TrendingDown,
    color: 'text-vexu-500'
  }, {
    value: '50%+',
    label: 'Efficiency Improvement',
    icon: TrendingUp,
    color: 'text-vexu-600'
  }, {
    value: '100%',
    label: 'Operational Visibility',
    icon: Eye,
    color: 'text-charcoal-700'
  }, {
    value: 'Zero',
    label: 'Reduced Human Error',
    icon: ShieldCheck,
    color: 'text-charcoal-800'
  }];
  return <SlideWrapper className="items-center text-center" data-id="element-321">
      <motion.div variants={staggerContainer} initial="hidden" animate="show" className="max-w-6xl w-full h-full flex flex-col justify-center py-8 md:py-12" data-id="element-322">
        <motion.h2 variants={fadeUpItem} className="text-3xl md:text-5xl font-heading font-bold mb-2 md:mb-4 text-charcoal-900" data-id="element-323">
          Value & Impact
        </motion.h2>
        <motion.p variants={fadeUpItem} className="text-base md:text-xl text-gray-500 mb-8 md:mb-12" data-id="element-324">
          From Complexity to Simplicity
        </motion.p>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-12 items-center" data-id="element-325">
          {/* Left Panel: Before / After */}
          <div className="flex flex-col gap-4 md:gap-6" data-id="element-326">
            <motion.div variants={scaleUpItem} className="p-5 md:p-8 rounded-3xl bg-white border border-red-100 shadow-sm text-left" data-id="element-327">
              <h3 className="text-xl md:text-2xl font-bold font-heading mb-4 md:mb-6 text-red-500" data-id="element-328">
                Before
              </h3>
              <ul className="space-y-3 md:space-y-4" data-id="element-329">
                {['Multiple fragmented systems', 'Disconnected workflows', 'Manual, repetitive operations'].map((item, i) => <li key={i} className="flex items-center gap-3 md:gap-4 text-base md:text-lg text-gray-700" data-id="element-330">
                    <div className="p-1 md:p-1.5 rounded-full bg-red-50 text-red-500 shrink-0" data-id="element-331">
                      <TrendingDown className="w-3 h-3 md:w-4 md:h-4" data-id="element-332" />
                    </div>
                    {item}
                  </li>)}
              </ul>
            </motion.div>

            <motion.div variants={scaleUpItem} className="p-5 md:p-8 rounded-3xl border border-vexu-200  text-left relative overflow-hidden bg-[#FFFFFF]" data-id="element-333">
              <div className="absolute inset-0 bg-gradient-to-br from-white/40 to-transparent pointer-events-none" data-id="element-334" />
              <h3 className="text-xl md:text-2xl font-bold font-heading mb-4 md:mb-6 text-vexu-600 relative z-10" data-id="element-335">
                After
              </h3>
              <ul className="space-y-3 md:space-y-4 relative z-10" data-id="element-336">
                {['One unified platform', 'Fully connected system', 'AI-driven execution'].map((item, i) => <li key={i} className="flex items-center gap-3 md:gap-4 text-base md:text-lg text-charcoal-900 font-medium" data-id="element-337">
                    <div className="p-1 md:p-1.5 rounded-full bg-white text-vexu-500 shrink-0 shadow-sm" data-id="element-338">
                      <TrendingUp className="w-3 h-3 md:w-4 md:h-4" data-id="element-339" />
                    </div>
                    {item}
                  </li>)}
              </ul>
            </motion.div>
          </div>

          {/* Right Panel: Stats */}
          <div className="grid grid-cols-2 gap-4 md:gap-6" data-id="element-340">
            {stats.map((stat, i) => <motion.div key={i} variants={scaleUpItem} className="p-4 md:p-8 rounded-3xl bg-white border border-gray-100 shadow-sm flex flex-col items-center justify-center gap-2 md:gap-3 hover: hover:border-vexu-200 transition-all group text-center" data-id="element-341">
                <stat.icon className={`w-6 h-6 md:w-8 md:h-8 ${stat.color} opacity-50 group-hover:opacity-100 transition-opacity`} data-id="element-342" />
                <h3 className={`text-2xl md:text-4xl lg:text-5xl font-heading font-bold ${stat.color}`} data-id="element-343">
                  {stat.value}
                </h3>
                <p className="text-xs md:text-lg text-gray-600 font-medium leading-tight" data-id="element-344">
                  {stat.label}
                </p>
              </motion.div>)}
          </div>
        </div>
      </motion.div>
    </SlideWrapper>;
}
export function Slide14() {
  return <SlideWrapper className="items-center text-center" data-id="element-345">
      <motion.div variants={staggerContainer} initial="hidden" animate="show" className="max-w-5xl w-full" data-id="element-346">
        <motion.h2 variants={fadeUpItem} className="text-3xl md:text-5xl font-heading font-bold mb-8 md:mb-16 text-charcoal-900" data-id="element-347">
          Business Impact
        </motion.h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-8" data-id="element-348">
          {stats.map((stat, i) => <motion.div key={i} variants={scaleUpItem} className="p-6 md:p-10 rounded-3xl bg-white border border-gray-100 shadow-sm flex flex-col items-center justify-center gap-3 md:gap-4 hover: hover:border-vexu-200 transition-all group" data-id="element-349">
              <stat.icon className={`w-8 h-8 md:w-10 md:h-10 ${stat.color} opacity-50 group-hover:opacity-100 transition-opacity`} data-id="element-350" />
              <h3 className={`text-4xl md:text-6xl font-heading font-bold ${stat.color}`} data-id="element-351">
                {stat.value}
              </h3>
              <p className="text-lg md:text-2xl text-gray-600 font-medium" data-id="element-352">
                {stat.label}
              </p>
            </motion.div>)}
        </div>
      </motion.div>
    </SlideWrapper>;
}
export function Slide15() {
  return <SlideWrapper className="items-center text-center" data-id="element-353">
      <motion.div variants={staggerContainer} initial="hidden" animate="show" className="max-w-4xl w-full flex flex-col items-center" data-id="element-354">
        <motion.div variants={scaleUpItem} className="mb-6 md:mb-8 flex items-center gap-4 md:gap-6" data-id="element-355">
          <img src={NEXA_LOGO} alt="Nexa42" className="w-10 h-10 md:w-16 md:h-16 object-contain rounded-lg" data-id="element-356" />
          <span className="text-2xl md:text-4xl text-gray-300 font-light" data-id="element-357">
            +
          </span>
          <img src={VEXU_LOGO} alt="Vexu AI" className="w-10 h-10 md:w-16 md:h-16 object-contain" data-id="element-358" />
        </motion.div>

        <motion.div variants={scaleUpItem} className="mb-8 md:mb-12 inline-block" data-id="element-359">
          <div className="px-4 py-1.5 md:px-6 md:py-2 rounded-full border border-gray-200 bg-white text-gray-500 text-[0.625rem] md:text-sm font-bold tracking-[0.3em] uppercase shadow-sm" data-id="element-360">
            The Future of Business Operations
          </div>
        </motion.div>

        <motion.div variants={fadeUpItem} className="relative" data-id="element-361">
          <div className="absolute -top-6 -left-6 md:-top-10 md:-left-10 text-5xl md:text-8xl text-mint-200 font-heading" data-id="element-362">
            "
          </div>
          <h2 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold leading-tight mb-6 md:mb-8 relative z-10 text-charcoal-900" data-id="element-363">
            <span className="text-charcoal-900" data-id="element-364">NeXa42</span> runs your
            business.
            <br data-id="element-365" />
            <span className="text-vexu-600" data-id="element-366">Vexu AI makes it autonomous.</span>
          </h2>
          <div className="absolute -bottom-10 -right-6 md:-bottom-20 md:-right-10 text-5xl md:text-8xl text-mint-200 font-heading" data-id="element-367">
            "
          </div>
        </motion.div>

        <motion.div variants={fadeUpItem} className="mt-16 md:mt-24" data-id="element-368">
          <div className="w-16 md:w-24 h-1 bg-gradient-to-r from-transparent via-vexu-400 to-transparent mx-auto opacity-50" data-id="element-369" />
        </motion.div>
      </motion.div>
    </SlideWrapper>;
}